/**
 * KAPSULE Analytics - Shopify Global Tracking Script
 * Place this in theme.liquid before </body>
 */

(function () {
  'use strict';

  // --- HARD GUARD: prevents accidental double-init ---
  if (window.__KAPSULE_ANALYTICS_LOADED__) return;
  window.__KAPSULE_ANALYTICS_LOADED__ = true;

  // --- IMPORTANT: define KAPSULE immediately so other scripts never crash ---
  window.KAPSULE = window.KAPSULE || {};
  window.__KAPSULE_QUEUE__ = window.__KAPSULE_QUEUE__ || [];

  // Stub track: queues calls until init replaces it
  if (typeof window.KAPSULE.track !== 'function') {
    window.KAPSULE.track = function (event, payload) {
      window.__KAPSULE_QUEUE__.push({ event, payload });
    };
  }

  // Configuration
  const CONFIG = {
    WORKER_URL: 'https://kapsule-analytics.kapsule.workers.dev',
    SESSION_KEY: 'kapsule_session_id',
    SOURCE_KEY: 'kapsule_source',
    SESSION_DURATION: 30 * 60 * 1000, // 30 minutes
    DEBUG: new URLSearchParams(window.location.search).has('kdebug'), // works with ?kdebug=1
  };

  const SOURCE_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'creator_id',
    'content_id',
    'qr_id',
    'email_flow',
    'ad_id',
  ];

  function generateSessionId() {
    return 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11);
  }

  function getSessionId() {
    const storedSession = localStorage.getItem(CONFIG.SESSION_KEY);

    if (storedSession) {
      try {
        const parsed = JSON.parse(storedSession);
        const now = Date.now();

        if (now - parsed.created < CONFIG.SESSION_DURATION) {
          parsed.lastActivity = now;
          localStorage.setItem(CONFIG.SESSION_KEY, JSON.stringify(parsed));
          return parsed.id;
        }
      } catch (e) {
        // ignore and create a new session
      }
    }

    const sessionId = generateSessionId();
    const newSession = {
      id: sessionId,
      created: Date.now(),
      lastActivity: Date.now(),
    };

    localStorage.setItem(CONFIG.SESSION_KEY, JSON.stringify(newSession));
    return sessionId;
  }

  function captureSourceParams() {
    const existingSource = localStorage.getItem(CONFIG.SOURCE_KEY);
    if (existingSource) {
      try {
        return JSON.parse(existingSource);
      } catch (e) {
        // continue to recapture
      }
    }

    const urlParams = new URLSearchParams(window.location.search);
    const source = {};
    let hasParams = false;

    SOURCE_PARAMS.forEach((param) => {
      if (urlParams.has(param)) {
        source[param] = urlParams.get(param);
        hasParams = true;
      }
    });

    if (document.referrer) {
      source.referrer = document.referrer;
      hasParams = true;
    }

    source.landing_page = window.location.pathname;

    // Always store landing_page at least once
    localStorage.setItem(CONFIG.SOURCE_KEY, JSON.stringify(source));

    return source;
  }

  function getDeviceType() {
    return window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  }

  async function sendEvent(event, payload = {}) {
    const data = {
      event,
      session_id: getSessionId(),
      page: window.location.pathname,
      device: getDeviceType(),
      source: captureSourceParams(),
      payload: payload || {},
    };

    if (CONFIG.DEBUG) {
      console.log('[KAPSULE Analytics] Sending:', event, data);
    }

    try {
      const response = await fetch(`${CONFIG.WORKER_URL}/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        keepalive: true, // helps on unload/navigation
      });

      let result = null;
      try {
        result = await response.json();
      } catch (e) {
        // response may not be JSON; ignore
      }

      if (!response.ok) {
        console.error('[KAPSULE Analytics] Track error:', response.status, result);
      } else if (CONFIG.DEBUG) {
        console.log('[KAPSULE Analytics] Response:', result);
      }
    } catch (error) {
      console.error('[KAPSULE Analytics] Network error:', error);
    }
  }

  function trackPageView() {
    sendEvent('page_view', {
      title: document.title,
      url: window.location.href,
    });
  }

  function flushQueue() {
    const q = window.__KAPSULE_QUEUE__ || [];
    if (!q.length) return;
    if (CONFIG.DEBUG) console.log('[KAPSULE Analytics] Flushing queued events:', q.length);

    q.forEach(({ event, payload }) => {
      if (event && typeof event === 'string') sendEvent(event, payload || {});
    });
    window.__KAPSULE_QUEUE__ = [];
  }

  function init() {
    // Replace stub with real function
    window.KAPSULE.track = function (event, payload) {
      if (!event || typeof event !== 'string') {
        console.error('[KAPSULE Analytics] Invalid event name');
        return;
      }
      sendEvent(event, payload || {});
    };

    window.KAPSULE.getSessionId = getSessionId;

    // Debug indicators
    if (CONFIG.DEBUG) {
      console.log('[KAPSULE Analytics] Debug mode enabled');
      console.log('[KAPSULE Analytics] Session ID:', getSessionId());
      console.log('[KAPSULE Analytics] Source params:', captureSourceParams());
      console.log('[KAPSULE Analytics] Device:', getDeviceType());
    }

    // Track initial page view
    trackPageView();

    // Flush any early calls that happened before init
    flushQueue();
  }

  // Init immediately (don’t wait for DOMContentLoaded)
  // This avoids the "KAPSULE is not defined" timing issue.
  init();
})();
